"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const timelineItems = [{
  time: "09:00",
  title: "Analisi Neuromarketing",
  description: "Decodifica dei trigger decisionali del target B2B. Mappatura dei bias cognitivi che guidano la scelta del fornitore.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/neuromarketing_analysis.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/neuromarketing_analysis.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/neuromarketing_analysis.png-wvc-sizes",
  numeral: "I"
}, {
  time: "11:30",
  title: "Architettura Infrastrutturale",
  description: "Sviluppo del core tecnico. Codice pulito, velocità estrema e sicurezza per portali industriali ad alte prestazioni.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/digital_infrastructure.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/digital_infrastructure.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/digital_infrastructure.png-wvc-sizes",
  numeral: "II"
}, {
  time: "14:00",
  title: "Intelligence Logistica",
  description: "Incrocio dati doganali e flussi commerciali per identificare i partner esteri con il più alto potenziale di conversione.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logistics_intelligence.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logistics_intelligence.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logistics_intelligence.png-wvc-sizes",
  numeral: "III"
}, {
  time: "16:30",
  title: "SEO Strategica Internazionale",
  description: "Posizionamento chirurgico sulle keyword transazionali nei mercati target. Visibilità dove conta davvero.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/international_seo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/international_seo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/international_seo.png-wvc-sizes",
  numeral: "IV"
}, {
  time: "18:00",
  title: "Validazione Lead Generation",
  description: "Test dei flussi di acquisizione. Ottimizzazione dei tassi di risposta per garantire contatti commerciali qualificati.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/lead_validation.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/lead_validation.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/lead_validation.png-wvc-sizes",
  numeral: "V"
}, {
  time: "20:00",
  title: "Reporting Asimmetrico",
  description: "Consegna dei dati di penetrazione commerciale. Analisi dei risultati basata su fatti, non su metriche di vanità.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/asymmetric_reporting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/asymmetric_reporting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/asymmetric_reporting.png-wvc-sizes",
  numeral: "VI"
}, {
  time: "21:30",
  title: "Espansione Scalabile",
  description: "Pianificazione della fase successiva di export. Consolidamento della presenza digitale nei nuovi territori.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/scalable_expansion.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/scalable_expansion.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/scalable_expansion.png-wvc-sizes",
  numeral: "VII"
}, {
  time: "23:00",
  title: "Monitoraggio Globale",
  description: "Sistemi di sorveglianza attiva sulle performance dell'infrastruttura e sui movimenti della concorrenza estera.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/global_monitoring.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/global_monitoring.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/global_monitoring.png-wvc-sizes",
  numeral: "VIII"
}];
function TimelineRow({
  item,
  index
}: {
  item: (typeof timelineItems)[number];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15,
    rootMargin: "0px 0px -80px 0px"
  });
  const isLeft = index % 2 === 0;
  return <div data-index={index} ref={ref} className={`relative grid grid-cols-1 md:grid-cols-9 gap-6 md:gap-10 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      {}
      <div className="hidden md:flex md:col-start-5 md:col-end-6 absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-10 items-center justify-center">
        <div className="flex flex-col items-center">
          <span className="font-default text-xs tracking-[0.3em] font-bold" style={{
          color: "var(--primary)"
        }}>
            {item.numeral}
          </span>
          <span className="mt-2 block h-2.5 w-2.5 rounded-md" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>
      </div>

      {}
      <div className={`md:col-span-4 ${isLeft ? "md:order-1 md:text-right md:pr-12" : "md:order-3 md:pl-12"}`}>
        {isLeft ? <div className="flex flex-col md:items-end">
            <span className="font-serif text-5xl md:text-6xl font-bold leading-none" style={{
          color: "var(--primary)"
        }}>
              {item.time}
            </span>
            <h3 className="font-default mt-3 font-serif text-2xl md:text-3xl text-foreground leading-snug uppercase">
              {item.title}
            </h3>
            <p className="mt-4 text-muted-foreground text-base leading-relaxed max-w-sm md:text-right font-default">
              {item.description}
            </p>
          </div> : <div className="overflow-hidden rounded-md md:max-w-[200px] border border-border">
            <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.title} loading="lazy" decoding="async" className="w-full h-[200px] md:h-[200px] md:w-[200px] object-cover transition-transform duration-[1200ms] grayscale hover:grayscale-0" />
          </div>}
      </div>

      {}
      <div className="md:hidden absolute left-4 top-0 bottom-0 w-px" />

      {}
      <div className={`md:col-span-4 ${isLeft ? "md:order-3 md:pl-12" : "md:order-1 md:text-right md:pr-12"}`}>
        {isLeft ? <div className="overflow-hidden rounded-md md:max-w-[200px] border border-border">
            <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.title} loading="lazy" decoding="async" className="w-full h-[200px] md:h-[200px] md:w-[200px] object-cover transition-transform duration-[1200ms] grayscale hover:grayscale-0" />
          </div> : <div className="flex flex-col md:items-end">
            <span className="font-serif text-5xl md:text-6xl font-bold leading-none" style={{
          color: "var(--primary)"
        }}>
              {item.time}
            </span>
            <h3 className="font-default mt-3 font-serif text-2xl md:text-3xl text-foreground leading-snug uppercase">
              {item.title}
            </h3>
            <p className="mt-4 text-muted-foreground text-base leading-relaxed max-w-sm md:text-right font-default">
              {item.description}
            </p>
          </div>}
      </div>
    </div>;
}
export default function OperationalFoundation() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="83" id="operational-foundation" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="inline-block font-default text-xs md:text-sm tracking-[0.4em] uppercase font-bold" style={{
          color: "var(--primary)"
        }}>
            § 01 / Fondamenta Operative
          </span>
          <h2 className="font-default mt-6 font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-foreground leading-[1.05] font-bold uppercase">
            Ciclo di Intelligence
            <br />
            <span className="text-primary">Strategica.</span>
          </h2>
          <p className="mt-8 text-muted-foreground text-base md:text-lg leading-relaxed max-w-2xl mx-auto font-default">
            Un protocollo rigoroso, progettato per la penetrazione commerciale. 
            Dall'analisi clinica del target alla validazione dei flussi export, 
            ogni ora è dedicata alla costruzione del vostro vantaggio competitivo.
          </p>
          <div className="mx-auto mt-10 h-px w-16" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>

        {}
        <div className="relative mt-20 md:mt-28 max-w-[880px] mx-auto">
          {}
          <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px" style={{
          backgroundColor: "var(--primary)",
          opacity: 0.2
        }} aria-hidden="true" />
          {}
          <div className="md:hidden absolute left-4 top-0 bottom-0 w-px" style={{
          backgroundColor: "var(--primary)",
          opacity: 0.2
        }} aria-hidden="true" />

          <div className="flex flex-col gap-20 md:gap-24">
            {timelineItems.map((item, i) => <TimelineRow key={item.time} item={item} index={i} />)}
          </div>
        </div>

        {}
        <div ref={ctaRef} className={`mt-24 md:mt-32 flex flex-col items-center text-center transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="h-px w-16" style={{
          backgroundColor: "var(--primary)"
        }} />
          <p className="font-default mt-8 font-serif text-2xl md:text-3xl text-foreground max-w-xl leading-snug uppercase font-medium">
            O definite la vostra traiettoria.
          </p>
          <p className="mt-4 text-muted-foreground text-base max-w-lg font-default">
            I nostri analisti modellano l'infrastruttura attorno alle vostre specifiche esigenze di mercato e obiettivi di fatturato estero.
          </p>
          <Button size="lg" className="font-default mt-10 rounded-md px-10 py-6 text-sm tracking-[0.2em] uppercase font-bold shadow-md hover:shadow-lg transition-all" style={{
          backgroundColor: "var(--primary)",
          color: "var(--primary-foreground)"
        }}>
            Configura Strategia
          </Button>
        </div>
      </div>
    </section>;
}